import type { PickUpDto } from './pick-ups/models';
import type { CustomUpdateProfileDto } from './profiles/dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomProfileService {
  apiName = 'Default';
  

  getFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: `/api/app/custom-profile/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  getPickUps = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto[]>({
      method: 'GET',
      url: '/api/app/custom-profile/pick-ups',
    },
    { apiName: this.apiName,...config });
  

  getPickUpsBySommelier = (slug: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto[]>({
      method: 'GET',
      url: '/api/app/custom-profile/pick-ups-by-sommelier',
      params: { slug },
    },
    { apiName: this.apiName,...config });
  

  getProfile = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CustomUpdateProfileDto>({
      method: 'GET',
      url: '/api/app/custom-profile/profile',
    },
    { apiName: this.apiName,...config });
  

  updateProfile = (input: CustomUpdateProfileDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: '/api/app/custom-profile/profile',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  uploadProfileImage = (file: FormData, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/app/custom-profile/upload-profile-image',
      body: file,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
